import { useCurrentCompany } from 'hooks';
import { useMemo } from 'react';
import {
  combineUtms,
  getLocalStorageUtms,
  getUrlUtms,
} from 'utils/UTM-functions';
import { BASE_BOOK_CALL_URL } from './constants';

export interface BookCallButtonHook {
  url: string;
}

export default function useBookCallButton(): BookCallButtonHook {
  const { company } = useCurrentCompany();

  const utmUrl = useMemo(() => {
    const { search } = window.location;
    const urlUtms = getUrlUtms(search);
    const storedUtms = getLocalStorageUtms();
    const combined = combineUtms(urlUtms, storedUtms);
    if (Object.keys(combined).length === 0) return BASE_BOOK_CALL_URL;
    const utmString = Object.keys(combined).reduce(
      (str, utm) => `${str}&${utm}=${combined[utm]}`,
      '',
    );
    return `${BASE_BOOK_CALL_URL}?${utmString}`;
  }, []);

  const companyUtmUrl = useMemo(() => {
    if (!company) return null;
    const utms = company?.analytics?.utms;
    if (!utms || utms.length === 0) return null;
    const finalUtms = utms[0];
    const utmString = Object.keys(finalUtms).reduce(
      (str, utm) => `${str}&${utm}=${finalUtms[utm]}`,
      '',
    );
    return `${BASE_BOOK_CALL_URL}?${utmString}`;
  }, [company]);

  const url = useMemo(() => companyUtmUrl || utmUrl, [companyUtmUrl, utmUrl]);

  return {
    url,
  };
}
